module.exports = __webpack_public_path__ + "img/blanket_6.566b9aa3.png";